import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Download, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, fileDownloadUrl } from "../lib/api";
import { ZoomableView, WaShareButton, ltrNums } from "./FilePreviewTools";

// In-app preview (no new tab) so the user can always close and return to where he was.
export const InAppFilePreview = ({ file, onClose }) => {
  const [view, setView] = useState(null);
  useEffect(() => {
    if (!file) return undefined;
    let url = null;
    let alive = true;
    setView(null);
    (async () => {
      try {
        const blob = await api.getFileBlob(file.id);
        if ((blob.type || "").includes("pdf") || (await blob.slice(0, 4).text()) === "%PDF") {
          const res = await api.getPdfPages(file.id);
          if (alive) setView({ pages: res.pages || [], mime: "application/pdf" });
        } else {
          url = URL.createObjectURL(blob);
          if (alive) setView({ url, mime: blob.type });
        }
      } catch { toast.error("تعذّر تحميل المعاينة"); onClose(); }
    })();
    // phone back button closes the preview instead of leaving the site
    window.history.pushState({ inappPreview: true }, "");
    const onPop = () => onClose();
    window.addEventListener("popstate", onPop);
    return () => {
      alive = false; if (url) URL.revokeObjectURL(url);
      window.removeEventListener("popstate", onPop);
      if (window.history.state?.inappPreview) window.history.back();
    };
  }, [file]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={Boolean(file)} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="sm:max-w-3xl font-body max-h-[92vh] overflow-hidden" dir="rtl" data-testid="inapp-preview-dialog">
        <DialogHeader className="text-right pr-8">
          <DialogTitle className="font-heading text-lg truncate">{ltrNums(file?.name) || "معاينة المرفق"}</DialogTitle>
        </DialogHeader>
        {!view ? <div className="py-16 text-center"><Loader2 className="mx-auto h-6 w-6 animate-spin text-slate-400" /></div>
          : <ZoomableView srcs={view.pages || [view.url]} alt={file?.name} maxH="max-h-[62vh]"
              extra={<WaShareButton attachmentId={file?.id} name={file?.name} mime={view.mime} employeeId={file?.employeeId} employeeName={file?.employeeName} />} />}
        <div className="flex gap-2">
          <button type="button" data-testid="inapp-preview-back" onClick={onClose}
            className="flex-1 inline-flex items-center justify-center gap-1.5 rounded-lg bg-slate-900 text-white py-2.5 text-sm font-semibold active:scale-95 transition-transform">
            <X className="h-4 w-4" /> رجوع
          </button>
          {file && <a href={fileDownloadUrl(file.id)} data-testid="inapp-preview-download"
            className="inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-200 px-4 py-2.5 text-sm text-slate-700"><Download className="h-4 w-4" /> تنزيل</a>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
